import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  api,
  callApiSaqsCreate,
  callApiSaqsPatch,
  callApiSaqsDelete,
  callApiFetchWhiteLabelBusinessUsers,
  callApiFetchBusinessUsers,
  callApiUpdateBusiness,
} from "../../services/index";

import { setStorageItem, removeAllStorage } from "../../helpers/";

import {
  SAQ_CREATE_SUCCESS,
  SAQ_DELETE_SUCCESS,
  WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS,
  WHITE_LABEL_BUSINESS_USER_FETCH_ERROR,
  BUSINESS_USER_FETCH_SUCCESS,
  BUSINESS_USER_FETCH_ERROR,
  BUSINESS_STATUS_UPDATE_SUCCESS,
  BUSINESS_STATUS_UPDATE_ERROR,
} from "../types";

export const fetchWhiteLabelBusinessUsers = (data) => {
  return async (dispatch) => {
    if (data.businessId) {
      const businessId = data.businessId;

      return callApiFetchWhiteLabelBusinessUsers(businessId).then(
        async (res) => {
          if (res.success) {
            dispatch({
              type: WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS,
              payload: res,
            });
          } else {
            dispatch({
              type: WHITE_LABEL_BUSINESS_USER_FETCH_ERROR,
              payload: res,
            });
          }
        }
      );
    }
  };
};

export const fetchBusinessUsers = (data) => {
  return async (dispatch) => {
    if (data.businessId) {
      const businessId = data.businessId;

      return callApiFetchBusinessUsers(businessId).then(async (res) => {
        if (res.success) {
          dispatch({
            type: BUSINESS_USER_FETCH_SUCCESS,
            payload: res,
          });
        } else {
          dispatch({
            type: BUSINESS_USER_FETCH_ERROR,
            payload: res,
          });
        }
      });
    }
  };
};

export const onClickUpdateBusiness = (data) => {
  return async (dispatch) => {
    if (data.businessId) {
      const businessId = data.businessId;

      return callApiUpdateBusiness(data).then(async (res) => {
        if (res.success) {
          dispatch({
            type: BUSINESS_STATUS_UPDATE_SUCCESS,
            payload: res,
          });

          toast.success("Status changed successfully.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        } else {
          dispatch({
            type: BUSINESS_STATUS_UPDATE_ERROR,
            payload: res,
          });

          toast.error("Status change was unsuccessfull.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        }
      });
    }
  };
};
